module.exports = __webpack_public_path__ + "static/media/all-this-time.2daa88db.mp3";